export default __webpack_public_path__ + "static/media/Q_Matting.395bdcc0.jpg";